<template>
  <div class="relative">
    <MediaAspectRatio :aspect-ratio="aspectRatio" class="overflow-hidden rounded-sm border border-strong">
      <img
        v-if="contentType.startsWith('image')"
        :key="url"
        draggable="false"
        :alt="name"
        class="asset"
        :class="{ 'opacity-25': disabled }"
        :src="url"
        data-testid="asset-preview-image"
      />
      <video
        v-if="contentType.startsWith('video')"
        :key="url"
        class="asset"
        :class="{ 'opacity-25': disabled }"
        controls
        :poster="posterUrl || undefined"
        :src="posterUrl ? url : `${url}#t=0.05`"
        data-testid="asset-preview-video"
      />
    </MediaAspectRatio>
    <MdiSvg v-if="disabled" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform" :path="mdiEyeOff" />
  </div>
</template>

<script setup lang="ts">
import { mdiEyeOff } from '@mdi/js'
import { MediaAspectRatio, MdiSvg } from '@ramp106/omrjs-core-ui'

withDefaults(
  defineProps<{
    contentType: string
    url: string
    name?: string
    aspectRatio?: string
    disabled?: boolean
    posterUrl?: string
  }>(),
  {
    aspectRatio: '16:9',
    name: '',
    disabled: false,
    posterUrl: undefined,
  },
)
</script>
<style lang="css" scoped>
@reference '@ramp106/omrjs-config-tailwind/styles/index.css';

.asset {
  @apply h-full w-full object-cover;
}
</style>
